import firebase from 'firebase';
import { getfirebaseid, callcloudfunction } from '@/functions.js';

export default{

    mutations: {
        setContacts(state, payload) {
            this.state.contacts = payload;
            this.state.updatecount++;
        },
        addContact(state, payload) {
            //alert('addContact');
            if (payload.Groups == null)
                payload.Groups = [];
            this.state.contacts.push(payload);
            this.state.updatecount++;
        },
        cutContact(state,payload){
            const deleted = this.state.contacts.find(contact => contact.ID === payload);
            const index = this.state.contacts.indexOf(deleted);
            this.state.contacts.splice(index, 1);
            this.state.updatecount++;
        },
        changedContact(state, payload) {
            //alert('changedContact ' + payload.Name);
            var changed = this.state.contacts.find(contact => contact.ID === payload.ID);
            changed.Name = payload.Name;
            changed.Email = payload.Email;
            changed.Registered = payload.Registered;
            changed.DatabaseID = payload.DatabaseID;
            changed.GroupCount = payload.GroupCount;
            changed.Groups = payload.Groups;
            this.state.updatecount++;
        },
    },
    actions: {
        checkInvite(state, invite) {
            var invitesRef = firebase.database().ref('invites');
            var thisthis = this;
            invitesRef.orderByChild("Email").equalTo(invite.email).on("value", function (snapshot) {
                if (snapshot.exists()) {
                    snapshot.forEach(function (child) {
                        var invitedbID = child.val().DatabaseID;
                        var inviteuserID = child.val().UserID;
                        var contactID = child.key;
                        thisthis.dispatch('setInvite', { database: invitedbID, user: inviteuserID, contact: contactID, regdb:invite.db, reg: state.rootState.user.uid});
                    });
                }
            });
        },
        checkExisitingContact(state, contact) {
            //alert("checking Existing Users");
            var usersRef = firebase.database().ref('usercore');
            var thisthis = this;
            usersRef.orderByChild("Email").equalTo(contact.Email).on("value", function (snapshot) {
                if (snapshot.exists()) {
                    snapshot.forEach(function (child) {
                        //msg = msg + child.val().exp_date;
                        //alert("User found " + child.key)
                        contact.Registered = child.key;
                        contact.ID = getfirebaseid();
                        thisthis.dispatch('setContact',contact);
                    });
                }
                else {
                    //alert("User not found");
                    delete contact.Registered;
                    contact.ID = getfirebaseid();
                    //now send invite and add to invited list
                    var invitorstring = state.rootState.currentuser.Name;
                    if (state.rootState.currentuser.Organisation.length > 0) {
                        invitorstring += " at " + state.rootState.currentuser.Organisation;
                    }
                    state.rootState.addingcontact = contact;
                    callcloudfunction("sendMail", "invite", {email:contact.Email, invitor:invitorstring}, thisthis,"contactChecked");             
                }
            });
        },
        contactChecked(state, res) {
            //alert("contactChecked " + res);
            if (res === "OK") {
                var invite = { DatabaseID: state.rootState.databaseid, UserID: state.rootState.user.uid, Email: state.rootState.addingcontact.Email };
                firebase.database().ref('invites/' + state.rootState.addingcontact.ID).set(invite);
                this.dispatch('setContact', state.rootState.addingcontact);
            }
            else {
                confirm("There is a problem with the email so the contact has not been added.");
            }
        },
        addContact(state, contact) {
            //alert("addContact");
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mycontacts').push(contact);
        },
        cutContact( state , contact) {
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mycontacts/'+contact.ID).remove();
        },
        setContact(state, contact) {
            //alert("setContact");
            var dat = { ...contact };
            delete (dat.ID);
            delete (dat.GroupCount);
            delete (dat.IsSelected);
            delete (dat.val);
            if ((dat.Groups==null) || ((dat.Groups != null) && (dat.Groups.length == 0)))
                delete (dat.Groups);
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mycontacts/' + contact.ID).set(dat);
        },
        setInvite(state, invite) {
            //alert("check setInvite");
            firebase.database().ref('databases/' + invite.database + '/users/' + invite.user + '/mydata/mycontacts/' + invite.contact + '/Registered').set(invite.reg);
            firebase.database().ref('databases/' + invite.database + '/users/' + invite.user + '/mydata/mycontacts/' + invite.contact + '/DatabaseID').set(invite.regdb);
            firebase.database().ref('invites/' + invite.contact).remove();

        }
    }
}